module.exports = __webpack_public_path__ + "img/img19.be59bdb0.jpg";